import { createAsyncThunk } from "@reduxjs/toolkit";
import { dashboardCertificationCompliance, getClientDetailAPI, getClientListAPI } from "../../apiConfig/apiCall";

export const getClients = createAsyncThunk('getClients', async () => {
    const response = await getClientListAPI();
    return response.data;
});

export const getClientDetails = createAsyncThunk('getClientDetails', async (ID) => {
    const response = await getClientDetailAPI(ID);
    return response.data;
});

export const getProjectCertifications = createAsyncThunk('getProjectCertifications', async (CLIENT_ID) => {
    const response = await dashboardCertificationCompliance(CLIENT_ID);
    return response.data;
});